export const projects = [
  {
    id: 1,
    title: {
      en: "Gas Boiler Management System",
      sr: "Sistem za upravljanje gasnim kotlovima"
    },
    shortDescription: {
      en: "Full-stack heating management platform with real-time automatic temperature control",
      sr: "Full-stack platforma za upravljanje grejanjem sa automatskom kontrolom temperature u realnom vremenu"
    },
    fullDescription: {
      en: `A full-stack web application for monitoring and managing gas boiler heating systems across multiple buildings. Features automatic temperature regulation through a Proportional (P) controller algorithm that runs every 60 seconds, adjusting boiler power based on thermodynamic calculations and real outdoor weather data.

The system provides real-time WebSocket updates via SignalR, an interactive Leaflet map with live temperature overlays, an alarm system for insufficient boiler capacity, and historical charts for temperature, heat loss, and cost analysis. Role-based access separates Admin and User functionality.`,
      sr: `Full-stack web aplikacija za monitoring i upravljanje sistemima grejanja sa gasnim kotlovima u više zgrada. Ima automatsku regulaciju temperature putem algoritma proporcionalnog (P) kontrolera koji se izvršava svakih 60 sekundi, podešavajući snagu kotla na osnovu termodinamičkih kalkulacija i stvarnih vremenskih podataka.

Sistem pruža ažuriranja u realnom vremenu putem SignalR WebSocket-a, interaktivnu Leaflet mapu sa prikazom temperature uživo, sistem alarma za nedovoljni kapacitet kotla i istorijske grafikone za temperaturu, gubitke toplote i analizu troškova. Pristup baziran na ulogama razdvaja funkcionalnosti Admina i Korisnika.`
    },
    technologies: [".NET 8", "C#", "React", "TypeScript", "SignalR", "SQL Server", "Entity Framework", "JWT", "Leaflet", "Chart.js"],
    highlights: {
      en: [
        "P-controller algorithm for automatic boiler power regulation",
        "Real-time WebSocket updates via SignalR",
        "Interactive Leaflet map with live temperature overlays",
        "OpenWeatherMap API integration for heat loss calculation",
        "Alarm system for insufficient boiler capacity",
        "Role-based access control (Admin/User)",
        "CSV export of historical building data"
      ],
      sr: [
        "P-kontroler algoritam za automatsku regulaciju snage kotla",
        "Ažuriranja u realnom vremenu putem SignalR WebSocket-a",
        "Interaktivna Leaflet mapa sa prikazom temperature uživo",
        "Integracija OpenWeatherMap API-ja za kalkulaciju gubitka toplote",
        "Sistem alarma za nedovoljni kapacitet kotla",
        "Kontrola pristupa bazirana na ulogama (Admin/Korisnik)",
        "CSV export istorijskih podataka o zgradama"
      ]
    },
    github: "https://github.com/Bat0oo/Gas-Boiler-Web-Application",
    featured: true,
    category: ["backend", "fullstack"]
  },
  {
    id: 2,
    title: {
      en: "Document Chat Q&A",
      sr: "Document Chat Q&A"
    },
    shortDescription: {
      en: "AI-powered platform for uploading documents and querying them via natural-language chat",
      sr: "AI platforma za upload dokumenata i upite putem chata na prirodnom jeziku"
    },
    fullDescription: {
      en: `An application that lets users upload documents (PDF, DOCX, etc.), then interact with their content through a natural-language chat interface. The system uses document embeddings and AI model integration to provide contextually relevant answers based on the uploaded content.

Built with a Service Fabric microservices backend and React frontend, the platform maintains persistent conversation context and supports a wide range of use cases — from internal knowledge-base assistants and research tools to educational and compliance applications.`,
      sr: `Aplikacija koja korisnicima omogućava upload dokumenata (PDF, DOCX, itd.), a zatim interakciju sa njihovim sadržajem putem chat interfejsa na prirodnom jeziku. Sistem koristi document embeddings i integraciju AI modela za pružanje kontekstualno relevantnih odgovora na osnovu uploadovanog sadržaja.

Izgrađen sa Service Fabric mikroservisnim backend-om i React frontend-om, platforma održava persistentni kontekst razgovora i podržava širok spektar primjena — od internih asistenata za bazu znanja i istraživačkih alata do obrazovnih i compliance aplikacija.`
    },
    technologies: ["C#", ".NET", "Service Fabric", "React", "MongoDB", "Groq AI"],
    highlights: {
      en: [
        "PDF and DOCX document upload and parsing",
        "Document embeddings for semantic search",
        "Natural-language Q&A with persistent chat context",
        "Service Fabric microservices architecture",
        "Groq AI model integration for answer generation",
        "MongoDB for document and conversation storage"
      ],
      sr: [
        "Upload i parsiranje PDF i DOCX dokumenata",
        "Document embeddings za semantičku pretragu",
        "Q&A na prirodnom jeziku sa persistentnim kontekstom chata",
        "Service Fabric mikroservisna arhitektura",
        "Integracija Groq AI modela za generisanje odgovora",
        "MongoDB za čuvanje dokumenata i razgovora"
      ]
    },
    github: "https://github.com/Bat0oo/DocumentChatQ-A",
    featured: true,
    category: ["backend", "fullstack"]
  },
  {
    id: 3,
    title: {
      en: "Rubik's Cube API",
      sr: "Rubik's Cube API"
    },
    shortDescription: {
      en: "REST API for Rubik's Cube simulation with state persistence",
      sr: "REST API za Rubikovu kocku sa perzistencijom stanja"
    },
    fullDescription: {
      en: `A RESTful API built with Ruby on Rails for simulating a Rubik's Cube. The API provides endpoints for manually manipulating the cube through standard notation moves (R, L, U, D, F, B) with state persistence in SQL Server.
      
Currently backend-only (no frontend), the API is designed for testing via Postman or similar tools. Future plans include adding a scramble feature for random cube configurations. Perfect for learning cube mechanics and REST API design.`,
      sr: `RESTful API izgrađen sa Ruby on Rails za simulaciju Rubikove kocke. API pruža endpoint-e za ručnu manipulaciju kockom kroz standardne notacijske pokrete (R, L, U, D, F, B) sa perzistencijom stanja u SQL Server-u.
      
Trenutno samo backend (bez frontend-a), API je dizajniran za testiranje preko Postman-a ili sličnih alata. Budući planovi uključuju dodavanje funkcije za nasumično mešanje kocke. Savršen za učenje mehanike kocke i REST API dizajna.`
    },
    technologies: ["Ruby on Rails", "SQL Server", "REST API", "Ruby"],
    highlights: {
      en: [
        "Standard cube notation support (R, L, U, D, F, B)",
        "SQL Server state persistence",
        "RESTful endpoint design",
        "Backend-only architecture",
        "Testable via Postman"
      ],
      sr: [
        "Podrška za standardnu notaciju kocke (R, L, U, D, F, B)",
        "SQL Server perzistencija stanja",
        "RESTful endpoint dizajn",
        "Samo backend arhitektura",
        "Testiranje preko Postman-a"
      ]
    },
    github: "https://github.com/Bat0oo/rubik-s-cube",
    featured: true,
    category: ["backend"]
  },
  {
    id: 4,
    title: {
      en: "PUGS - Taxi Service Simulation",
      sr: "PUGS - Simulacija taksi servisa"
    },
    shortDescription: {
      en: "Full-stack taxi platform with microservices architecture",
      sr: "Full-stack taksi platforma sa mikroservisnom arhitekturom"
    },
    fullDescription: {
      en: `A comprehensive taxi service simulation demonstrating microservices architecture using Service Fabric. The platform features three distinct user roles (Admin, Rider, Driver) with role-based access control and an intelligent ride estimation service.
      
The system calculates ride duration, estimated price, and arrival time, providing a complete ride-sharing experience. Built with modern technologies and cloud-native principles, it showcases distributed system design with clean separation of concerns.`,
      sr: `Kompleksna simulacija taksi servisa koja demonstrira mikroservisnu arhitekturu koristeći Service Fabric. Platforma ima tri različite korisničke uloge (Admin, Vozač, Putnik) sa kontrolom pristupa baziranom na ulogama i inteligentnim servisom za procenu vožnje.
      
Sistem izračunava trajanje vožnje, procenjenu cenu i vreme dolaska, pružajući kompletan ride-sharing doživljaj. Izgrađen sa modernim tehnologijama i cloud-native principima, prikazuje dizajn distribuiranog sistema sa čistom separacijom odgovornosti.`
    },
    technologies: ["React", ".NET Core", "Service Fabric", "Azure Blob Storage", "C#"],
    highlights: {
      en: [
        "Microservices architecture with Service Fabric",
        "Role-based authentication (Admin/Rider/Driver)",
        "Real-time ride estimation algorithms",
        "RESTful API design",
        "Cloud-native deployment"
      ],
      sr: [
        "Mikroservisna arhitektura sa Service Fabric",
        "Autentifikacija bazirana na ulogama (Admin/Vozač/Putnik)",
        "Real-time algoritmi za procenu vožnje",
        "RESTful API dizajn",
        "Cloud-native deployment"
      ]
    },
    github: "https://github.com/Bat0oo/PUGS-Projekat",
    featured: true,
    category: ["backend", "fullstack", "cloud"]
  },
  {
    id: 5,
    title: {
      en: "Cloud Bookstore with Banking Service",
      sr: "Cloud Bookstore sa Banking servisom"
    },
    shortDescription: {
      en: "E-commerce platform with integrated banking microservice",
      sr: "E-commerce platforma sa integrisanim bankarskim mikroservisom"
    },
    fullDescription: {
      en: `A cloud-based bookstore demonstrating distributed system design with separate microservices for bookstore operations and banking. Users can deposit money into their accounts through the banking service, then purchase books if they have sufficient balance.
      
The system showcases inter-service communication patterns, transaction handling, and microservices orchestration using Service Fabric. Built with .NET and React, it demonstrates how to build scalable e-commerce solutions in the cloud.`,
      sr: `Cloud bookstore koji demonstrira dizajn distribuiranog sistema sa odvojenim mikroservisima za poslovanje knjižare i bankarstva. Korisnici mogu da deponuju novac na svoje naloge preko bankarskog servisa, a zatim kupuju knjige ako imaju dovoljno sredstava.
      
Sistem prikazuje obrasce komunikacije između servisa, rukovanje transakcijama i orkestraciju mikroservisa koristeći Service Fabric. Izgrađen sa .NET i React, demonstrira kako graditi skalabilna e-commerce rešenja u cloud-u.`
    },
    technologies: [".NET", "Service Fabric", "React", "C#", "Azure"],
    highlights: {
      en: [
        "Separate banking microservice",
        "Inter-service communication",
        "Account-based transaction system",
        "Service Fabric orchestration",
        "Cloud-native architecture"
      ],
      sr: [
        "Odvojen bankarski mikroservis",
        "Komunikacija između servisa",
        "Sistem transakcija baziran na nalozima",
        "Service Fabric orkestracija",
        "Cloud-native arhitektura"
      ]
    },
    github: "https://github.com/Bat0oo/Cloud_Racunarstvo_BookStore",
    featured: false,
    category: ["backend", "fullstack", "cloud"]
  },
  {
    id: 6,
    title: {
      en: "Crypto Portfolio Manager",
      sr: "Crypto Portfolio Manager"
    },
    shortDescription: {
      en: "Track cryptocurrency holdings with buy/sell management",
      sr: "Praćenje kriptovaluta sa kupovinom/prodajom"
    },
    fullDescription: {
      en: `A cloud-native application for managing imaginary cryptocurrency portfolios. Users can track their holdings, record buy/sell transactions, and monitor portfolio performance over time.
      
Built with cloud computing principles, this project demonstrates modern application architecture with scalable backend services and intuitive user interface. Perfect for learning portfolio management concepts and cloud deployment strategies.`,
      sr: `Cloud-native aplikacija za upravljanje imaginarnim kriptovalutnim portfolijima. Korisnici mogu pratiti svoja ulaganja, evidentirati kupovinu/prodaju transakcije i pratiti performanse portfolija tokom vremena.
      
Izgrađen sa principima cloud računarstva, ovaj projekat demonstrira modernu aplikativnu arhitekturu sa skalabilnim backend servisima i intuitivnim korisničkim interfejsom. Savršen za učenje koncepata upravljanja portfolijem i cloud deployment strategija.`
    },
    technologies: [".NET", "Cloud Architecture", "Azure"],
    highlights: {
      en: [
        "Portfolio tracking and analytics",
        "Buy/sell transaction management",
        "Cloud-native deployment",
        "Scalable architecture"
      ],
      sr: [
        "Praćenje i analitika portfolija",
        "Upravljanje kupovinom/prodajom",
        "Cloud-native deployment",
        "Skalabilna arhitektura"
      ]
    },
    github: "https://github.com/Bat0oo/RazvojCloudAplikacija_Projekat",
    featured: false,
    category: ["backend", "cloud"]
  },
  {
    id: 7,
    title: {
      en: "Air Quality Prediction System",
      sr: "Sistem za predviđanje kvaliteta vazduha"
    },
    shortDescription: {
      en: "ML-powered air quality forecasting for Serbian cities",
      sr: "ML predviđanje kvaliteta vazduha za srpske gradove"
    },
    fullDescription: {
      en: `A comprehensive machine learning application for predicting air quality metrics (SO2, PM2.5, PM10, O3, NO2, CO) for Serbian cities (Beograd, Novi Sad, Niš). Features a complete ETL pipeline, Random Forest models, and interactive Plotly visualizations.
      
The system includes EPA-standard AQI calculation with color-coded health categories, multiple chart types, and a demo module showcasing the entire ML workflow from data generation through prediction visualization. Built with modular architecture for easy maintenance and extension.`,
      sr: `Kompletna machine learning aplikacija za predviđanje metrika kvaliteta vazduha (SO2, PM2.5, PM10, O3, NO2, CO) za srpske gradove (Beograd, Novi Sad, Niš). Ima kompletan ETL pipeline, Random Forest modele i interaktivne Plotly vizuelizacije.
      
Sistem uključuje EPA-standard AQI kalkulaciju sa color-coded zdravstvenim kategorijama, više tipova grafika i demo modul koji prikazuje ceo ML workflow od generisanja podataka do vizuelizacije predikcija. Izgrađen sa modularnom arhitekturom za lako održavanje i proširivanje.`
    },
    technologies: ["Python", "Flask", "Random Forest", "Plotly", "MongoDB", "Pandas"],
    highlights: {
      en: [
        "Complete ETL pipeline for 3 Serbian cities",
        "EPA-standard AQI calculation",
        "6 pollutant predictions simultaneously",
        "Interactive Plotly dashboards",
        "Modular architecture (data/models/demo)"
      ],
      sr: [
        "Kompletan ETL pipeline za 3 srpska grada",
        "EPA-standard AQI kalkulacija",
        "6 predviđanja zagađivača istovremeno",
        "Interaktivne Plotly dashboard-e",
        "Modularna arhitektura (data/models/demo)"
      ]
    },
    github: "https://github.com/Bat0oo/air_quality_project",
    featured: false,
    category: ["python", "ml", "fullstack"]
  },
  {
    id: 8,
    title: {
      en: "IES - Electrical Grid Data Processor",
      sr: "IES - Procesor podataka električne mreže"
    },
    shortDescription: {
      en: "CIM/XML parser for power grid data",
      sr: "CIM/XML parser za podatke električne mreže"
    },
    fullDescription: {
      en: `A desktop application built with WPF for processing electrical grid data using the Common Information Model (CIM) standard. Features XML parsing capabilities, data format conversion, and profile generation for electrical grid components.
      
Integrated with Azure Blob Storage for cloud-based data management, the application includes visualization features for selecting and converting CIM data between different formats. Demonstrates enterprise-level data processing patterns for the energy sector.`,
      sr: `Desktop aplikacija izgrađena sa WPF za obradu podataka električne mreže koristeći Common Information Model (CIM) standard. Ima mogućnosti parsiranja XML-a, konverzije formata podataka i generisanja profila za komponente električne mreže.
      
Integrisana sa Azure Blob Storage za cloud upravljanje podacima, aplikacija uključuje vizuelizaciju za biranje i konvertovanje CIM podataka između različitih formata. Demonstrira enterprise-level obrasce obrade podataka za energetski sektor.`
    },
    technologies: [".NET", "WPF", "Azure Blob Storage", "CIM/XML", "C#"],
    highlights: {
      en: [
        "CIM/XML parsing for electrical grid data",
        "Data format conversion capabilities",
        "Azure Blob Storage integration",
        "Profile generation for grid components",
        "WPF desktop interface"
      ],
      sr: [
        "CIM/XML parsiranje za podatke električne mreže",
        "Mogućnosti konverzije formata podataka",
        "Azure Blob Storage integracija",
        "Generisanje profila za komponente mreže",
        "WPF desktop interfejs"
      ]
    },
    github: "https://github.com/Bat0oo/IES-Projekat",
    featured: false,
    category: ["backend", "cloud"]
  },
  {
    id: 9,
    title: {
      en: "AltitudeIT E-Commerce Platform",
      sr: "AltitudeIT E-Commerce platforma"
    },
    shortDescription: {
      en: "Full-stack e-commerce with Docker deployment",
      sr: "Full-stack e-commerce sa Docker deployment-om"
    },
    fullDescription: {
      en: `A complete e-commerce solution featuring React frontend and .NET backend, containerized with Docker for easy deployment. Includes comprehensive CRUD operations for users and products, statistical analytics dashboard, and user profile management.
      
The application demonstrates modern full-stack development practices with containerization, providing a scalable foundation for online retail. Features include product catalog management, user authentication, and business analytics reporting.`,
      sr: `Kompletno e-commerce rešenje sa React frontend-om i .NET backend-om, kontejnerizovano sa Docker-om za lako postavljanje. Uključuje sveobuhvatne CRUD operacije za korisnike i proizvode, statističku analitičku kontrolnu tablu i upravljanje korisničkim profilima.
      
Aplikacija demonstrira moderne full-stack razvojne prakse sa kontejnerizacijom, pružajući skalabilnu osnovu za online prodaju. Karakteristike uključuju upravljanje katalogom proizvoda, autentifikaciju korisnika i izveštavanje o poslovnoj analitici.`
    },
    technologies: ["React", ".NET", "SQL Server", "Docker", "Docker Compose"],
    highlights: {
      en: [
        "Docker containerized deployment",
        "CRUD operations for users and products",
        "Statistical analytics dashboard",
        "User profile management",
        "Product catalog system"
      ],
      sr: [
        "Docker kontejnerizovan deployment",
        "CRUD operacije za korisnike i proizvode",
        "Statistička analitička kontrolna tabla",
        "Upravljanje korisničkim profilima",
        "Sistem kataloga proizvoda"
      ]
    },
    github: "https://github.com/Bat0oo/AltitudeIT-Full-Stack",
    featured: false,
    category: ["fullstack", "frontend", "backend"]
  },
  {
    id: 10,
    title: {
      en: "SPARQL Nemanjić Dynasty Ontology",
      sr: "SPARQL Ontologija dinastije Nemanjića"
    },
    shortDescription: {
      en: "RDF/SPARQL ontology of the medieval Serbian Nemanjić dynasty",
      sr: "RDF/SPARQL ontologija srednjovjekovne srpske dinastije Nemanjića"
    },
    fullDescription: {
      en: `A formal ontology modeling the medieval Serbian Nemanjić dynasty (1166–1371), covering rulers, churches, territories, battles, legal documents, and key historical figures. Built as a master's course project in Smart Grid Software Architecture.

The ontology includes a UML class diagram designed in Enterprise Architect, an RDF/XML schema, Turtle files with 39 hand-crafted instances, and 20 SPARQL queries of varying complexity — 10 running against a local endpoint and 10 against Wikidata.`,
      sr: `Formalna ontologija koja modelira srednjovjekovnu srpsku dinastiju Nemanjića (1166–1371), pokrivajući vladare, crkve, teritorije, bitke, pravne dokumente i ključne istorijske ličnosti. Urađena kao projektni zadatak na master studijama.

Ontologija uključuje UML dijagram klasa dizajniran u Enterprise Architectu, RDF/XML shemu, Turtle fajlove sa 39 ručno kreiranih instanci i 20 SPARQL upita različite složenosti — 10 nad lokalnim endpointom i 10 nad Wikidatom.`
    },
    technologies: ["SPARQL 1.1", "RDF", "Turtle", "Wikidata", "Enterprise Architect"],
    highlights: {
      en: [
        "12 ontology classes modeling rulers, churches, territories, battles and more",
        "39 hand-crafted RDF instances covering the full dynasty",
        "20 SPARQL queries (10 local + 10 Wikidata)",
        "UML class diagram in Enterprise Architect",
        "M:N relation between rulers and territories across time periods",
        "Wikidata external endpoint integration"
      ],
      sr: [
        "12 klasa ontologije koje modeliraju vladare, crkve, teritorije, bitke i više",
        "39 ručno kreiranih RDF instanci pokriva cijelu dinastiju",
        "20 SPARQL upita (10 lokalnih + 10 Wikidata)",
        "UML dijagram klasa u Enterprise Architectu",
        "M:N relacija između vladara i teritorija kroz vremenska perioda",
        "Integracija sa Wikidata eksternim endpointom"
      ]
    },
    github: "https://github.com/Bat0oo/sparql_project",
    featured: false,
    category: ["backend"]
  }
];

export default projects;
